import { render } from "./MobileMenu.vue?vue&type=template&id=423ff5b0&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=423ff5b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423ff5b0"]])

export default __exports__